// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__ahjNZ","dragIcon":"Choice_dragIcon__3zSOj","left":"Choice_left__3uVCV","input":"Choice_input__3GsFJ"};